// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -------------------------------------------------
    Timepicker
   ------------------------------------------------- */
.air-datepicker-time {
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-column-gap: 12px;
  align-items: center;
  position: relative;
  margin: 18px;
  padding: 50px 0;
}
.-only-timepicker- .air-datepicker-time {
  border-top: none;
}

.air-datepicker-time--current {
  display: flex;
  align-items: center;
  flex: 1;
  font-size: 14px;
  text-align: center;
}

.air-datepicker-time--current-colon {
  margin: 0 2px 3px;
  line-height: 1;
}

.air-datepicker-time--current-hours,
.air-datepicker-time--current-minutes {
  line-height: 1;
  font-size: 19px;
  font-family: "Century Gothic", CenturyGothic, AppleGothic, sans-serif;
  position: relative;
  z-index: 1;
}
.air-datepicker-time--current-hours:after,
.air-datepicker-time--current-minutes:after {
  content: "";
  background: var(--adp-background-color-hover);
  border-radius: var(--adp-border-radius);
  position: absolute;
  left: -2px;
  top: -3px;
  right: -2px;
  bottom: -2px;
  z-index: -1;
  opacity: 0;
}
.air-datepicker-time--current-hours.-focus-:after,
.air-datepicker-time--current-minutes.-focus-:after {
  opacity: 1;
}

.air-datepicker-time--current-ampm {
  text-transform: uppercase;
  align-self: flex-end;
  color: var(--adp-time-day-period-color);
  margin-left: 6px;
  font-size: 11px;
  margin-bottom: 1px;
}

.air-datepicker-time--row {
  display: flex;
  align-items: center;
  font-size: 11px;
  height: 17px;
  background: linear-gradient(to right, var(--adp-time-track-color), var(--adp-time-track-color)) left 50%/100% var(--adp-time-track-height) no-repeat;
}
.air-datepicker-time--row:first-child {
  margin-bottom: 4px;
}
.air-datepicker-time--row input[type=range] {
  background: none;
  cursor: pointer;
  flex: 1;
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  -webkit-appearance: none;
}
.air-datepicker-time--row input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
}
.air-datepicker-time--row input[type=range]::-ms-tooltip {
  display: none;
}
.air-datepicker-time--row input[type=range]:hover::-webkit-slider-thumb {
  border-color: var(--adp-time-track-color-hover);
}
.air-datepicker-time--row input[type=range]:hover::-moz-range-thumb {
  border-color: var(--adp-time-track-color-hover);
}
.air-datepicker-time--row input[type=range]:hover::-ms-thumb {
  border-color: var(--adp-time-track-color-hover);
}
.air-datepicker-time--row input[type=range]:focus {
  outline: none;
}
.air-datepicker-time--row input[type=range]:focus::-webkit-slider-thumb {
  background: var(--adp-cell-background-color-selected);
  border-color: var(--adp-cell-background-color-selected);
}
.air-datepicker-time--row input[type=range]:focus::-moz-range-thumb {
  background: var(--adp-cell-background-color-selected);
  border-color: var(--adp-cell-background-color-selected);
}
.air-datepicker-time--row input[type=range]:focus::-ms-thumb {
  background: var(--adp-cell-background-color-selected);
  border-color: var(--adp-cell-background-color-selected);
}
.air-datepicker-time--row input[type=range]::-webkit-slider-thumb {
  box-sizing: border-box;
  height: 12px;
  width: 12px;
  border-radius: 3px;
  border: 1px solid var(--adp-time-track-color);
  background: #fff;
  cursor: pointer;
  transition: background var(--adp-transition-duration);
}
.air-datepicker-time--row input[type=range]::-moz-range-thumb {
  box-sizing: border-box;
  height: 12px;
  width: 12px;
  border-radius: 3px;
  border: 1px solid var(--adp-time-track-color);
  background: #fff;
  cursor: pointer;
  transition: background var(--adp-transition-duration);
}
.air-datepicker-time--row input[type=range]::-ms-thumb {
  box-sizing: border-box;
  height: 12px;
  width: 12px;
  border-radius: 3px;
  border: 1px solid var(--adp-time-track-color);
  background: #fff;
  cursor: pointer;
  transition: background var(--adp-transition-duration);
}
.air-datepicker-time--row input[type=range]::-webkit-slider-thumb {
  margin-top: calc(var(--adp-time-thumb-size) / 2 * -1);
}
.air-datepicker-time--row input[type=range]::-webkit-slider-runnable-track {
  border: none;
  height: var(--adp-time-track-height);
  cursor: pointer;
  color: transparent;
  background: transparent;
}
.air-datepicker-time--row input[type=range]::-moz-range-track {
  border: none;
  height: var(--adp-time-track-height);
  cursor: pointer;
  color: transparent;
  background: transparent;
}
.air-datepicker-time--row input[type=range]::-ms-track {
  border: none;
  height: var(--adp-time-track-height);
  cursor: pointer;
  color: transparent;
  background: transparent;
}
.air-datepicker-time--row input[type=range]::-ms-fill-lower {
  background: transparent;
}
.air-datepicker-time--row input[type=range]::-ms-fill-upper {
  background: transparent;
}`, "",{"version":3,"sources":["webpack://./src/libs/air-date-picker/src/datepickerTime.scss"],"names":[],"mappings":"AAAA;;sDAAA;AAuDA;EACE,aAAA;EACA,sCAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,YAAA;EACA,eAAA;AApDF;AAsDE;EACE,gBAAA;AApDJ;;AA2DA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,eAAA;EACA,kBAAA;AAxDF;;AA2DA;EACE,iBAAA;EACA,cAAA;AAxDF;;AA2DA;;EAEE,cAAA;EACA,eAAA;EACA,qEAAA;EACA,kBAAA;EACA,UAAA;AAxDF;AA0DE;;EACE,WAAA;EACA,6CAAA;EACA,uCAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AAvDJ;AA2DI;;EACE,UAAA;AAxDN;;AA6DA;EACE,yBAAA;EACA,oBAAA;EACA,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AA1DF;;AA6DA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,oJACE;AA3DJ;AA8DE;EACE,kBAAA;AA5DJ;AA+DE;EACE,gBAAA;EACA,eAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;AA7DJ;AA+DI;EACE,wBAAA;AA7DN;AAgEI;EACE,aAAA;AA9DN;AAnEE;EAsIM,+CAAA;AAhER;AAlEE;EAkIM,+CAAA;AA7DR;AAjEE;EA8HM,+CAAA;AA1DR;AA8DI;EACE,aAAA;AA5DN;AA/EE;EA8IM,qDAAA;EACA,uDAAA;AA5DR;AA/EE;EA0IM,qDAAA;EACA,uDAAA;AAxDR;AA/EE;EAsIM,qDAAA;EACA,uDAAA;AApDR;AA3FE;EAcA,sBAAA;EACA,YAhCe;EAiCf,WAjCe;EAkCf,kBAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;EAEA,qDAAA;AA+EF;AAjGE;EAUA,sBAAA;EACA,YAhCe;EAiCf,WAjCe;EAkCf,kBAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;EAEA,qDAAA;AAyFF;AAvGE;EAMA,sBAAA;EACA,YAhCe;EAiCf,WAjCe;EAkCf,kBAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;EAEA,qDAAA;AAmGF;AAiCI;EACE,qDAAA;AA/BN;AA1IE;EAwCA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;AAqGF;AA7IE;EAoCA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;AA4GF;AAhJE;EAgCA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;AAmHF;AAmBI;EACE,uBAAA;AAjBN;AAsBI;EACE,uBAAA;AApBN","sourcesContent":["/* -------------------------------------------------\n    Timepicker\n   ------------------------------------------------- */\n\n$rangeTrackBg: #dedede;\n$rangeThumbSize: 12px;\n\n@mixin trackSelector {\n  &::-webkit-slider-runnable-track {\n    @content;\n  }\n\n  &::-moz-range-track {\n    @content;\n  }\n\n  &::-ms-track {\n    @content;\n  }\n}\n\n@mixin thumbSelector {\n  &::-webkit-slider-thumb {\n    @content;\n  }\n\n  &::-moz-range-thumb {\n    @content;\n  }\n\n  &::-ms-thumb {\n    @content;\n  }\n}\n\n@mixin thumb {\n  box-sizing: border-box;\n  height: $rangeThumbSize;\n  width: $rangeThumbSize;\n  border-radius: 3px;\n  border: 1px solid var(--adp-time-track-color);\n  background: #fff;\n  cursor: pointer;\n\n  transition: background var(--adp-transition-duration);\n}\n\n@mixin track {\n  border: none;\n  height: var(--adp-time-track-height);\n  cursor: pointer;\n  color: transparent;\n  background: transparent;\n}\n\n.air-datepicker-time {\n  display: grid;\n  grid-template-columns: max-content 1fr;\n  grid-column-gap: 12px;\n  align-items: center;\n  position: relative;\n  // padding: 0 var(--adp-time-padding-inner);\n  margin: 18px;\n  padding: 50px 0;\n\n  .-only-timepicker- & {\n    border-top: none;\n  }\n}\n\n.air-datepicker-time--sliders {\n}\n\n.air-datepicker-time--current {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  font-size: 14px;\n  text-align: center;\n}\n\n.air-datepicker-time--current-colon {\n  margin: 0 2px 3px;\n  line-height: 1;\n}\n\n.air-datepicker-time--current-hours,\n.air-datepicker-time--current-minutes {\n  line-height: 1;\n  font-size: 19px;\n  font-family: \"Century Gothic\", CenturyGothic, AppleGothic, sans-serif;\n  position: relative;\n  z-index: 1;\n\n  &:after {\n    content: '';\n    background: var(--adp-background-color-hover);\n    border-radius: var(--adp-border-radius);\n    position: absolute;\n    left: -2px;\n    top: -3px;\n    right: -2px;\n    bottom: -2px;\n    z-index: -1;\n    opacity: 0;\n  }\n\n  &.-focus- {\n    &:after {\n      opacity: 1;\n    }\n  }\n}\n\n.air-datepicker-time--current-ampm {\n  text-transform: uppercase;\n  align-self: flex-end;\n  color: var(--adp-time-day-period-color);\n  margin-left: 6px;\n  font-size: 11px;\n  margin-bottom: 1px;\n}\n\n.air-datepicker-time--row {\n  display: flex;\n  align-items: center;\n  font-size: 11px;\n  height: 17px;\n  background:\n    linear-gradient(to right,var(--adp-time-track-color), var(--adp-time-track-color))\n    left 50%/100% var(--adp-time-track-height) no-repeat;\n\n  &:first-child {\n    margin-bottom: 4px;\n  }\n\n  input[type='range'] {\n    background: none;\n    cursor: pointer;\n    flex: 1;\n    height: 100%;\n    width: 100%;\n    padding: 0;\n    margin: 0;\n    -webkit-appearance: none;\n\n    &::-webkit-slider-thumb {\n      -webkit-appearance: none;\n    }\n\n    &::-ms-tooltip {\n      display: none;\n    }\n\n    &:hover {\n      @include thumbSelector() {\n        border-color: var(--adp-time-track-color-hover);\n      }\n    }\n\n    &:focus {\n      outline: none;\n\n      @include thumbSelector() {\n        background: var(--adp-cell-background-color-selected);\n        border-color: var(--adp-cell-background-color-selected);\n      }\n    }\n\n    //  Thumb\n    // -------------------------------------------------\n\n    @include thumbSelector() {\n      @include thumb;\n    }\n\n    &::-webkit-slider-thumb {\n      margin-top: calc(var(--adp-time-thumb-size) / 2 * -1);\n    }\n\n    //  Track\n    // -------------------------------------------------\n    @include trackSelector() {\n      @include track;\n    }\n\n    &::-ms-fill-lower {\n      background: transparent;\n    }\n    &:focus::-ms-fill-lower {\n\n    }\n    &::-ms-fill-upper {\n      background: transparent;\n    }\n    &:focus::-ms-fill-upper {\n\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
